import { Button } from 'Elements';

export const SubmitButton = ({ ...props }) => {
	return (
		<Button type="submit" {...props}>
			{!props.disabled && props.title}
			{props.disabled && props.disabledTitle}
		</Button>
	);
};

SubmitButton.defaultProps = {
	disabledTitle: 'در حال ارسال'
};
